<ion-content id="content-wrapper" fullscreen="true">
  <ion-grid class="h-100">
    <ion-row id="login-wrapper" class="h-100 ion-justify-content-center ion-align-items-center">
      <ion-col size-lg="auto" size="12">
        <div id="brand" class="ion-margin">
          <ion-img id="seos-logo" [src]="'assets/images/seos_logo.png'" (click)="onLogoClick()"></ion-img>
          <ion-img id="seos-text" [src]="'assets/images/seos_text.png'"></ion-img>
          <div id="seos-long-text">smart education operating system</div>
        </div>
      </ion-col>
      <ion-col id="divider" size="auto" class="ion-hide-lg-down"></ion-col>
      <ng-container *ngIf="!hasPairedLoginToken">
        <ion-col size-md="6" size-xl="4" size="12">
          <div id="form-wrapper" class="col p-4 p-xl-5">
            <form #loginForm="ngForm" class="w-100" (ngSubmit)="onSubmitForm(loginForm.valid, loginRequest)" (keyup.enter)="onSubmitForm(loginForm.valid, loginRequest)"
                  method="post" novalidate>
              <div class="title">{{ 'LOGIN.LOGIN_AS_STUDENT' | translate }}</div>
              <ion-item lines="none" class="ion-margin">
                <ion-input id="username"
                           type="text"
                           name="username"
                           inputmode="email"
                           [label]="'LOGIN.USERNAME' | translate"
                           labelPlacement="floating"
                           [(ngModel)]="loginRequest.username"
                           required>
                </ion-input>
              </ion-item>
              <ion-item lines="none" class="ion-margin">
                <ion-input id="password"
                           type="password"
                           name="password"
                           [label]="'LOGIN.PASSWORD' | translate"
                           labelPlacement="floating"
                           [(ngModel)]="loginRequest.password"
                           required>
                </ion-input>
              </ion-item>
              <ion-button id="login-btn" type="submit" class="ion-margin" [disabled]="loginForm.invalid" expand="block">
                {{ 'LOGIN.LOGIN_BTN' | translate }}
              </ion-button>
            </form>
            <div id="login-with-google" role="button" class="border-top border-secondary mt-4 pt-4 d-flex justify-content-center">
              <div id="g_id_onload"
                   [attr.data-client_id]="getWebAppClientId()"
                   data-callback="handleCredentialResponse">
              </div>
              <div class="g_id_signin" data-type="standard" data-theme="filled_blue"></div>
              <!--              <div class="g_id_signin" data-type="standard" data-theme="filled_blue" data-locale="hu_HU"></div>-->
              <!--              <asl-google-signin-button></asl-google-signin-button>-->
            </div>
            <div id="privacy-policy-link" class="d-flex justify-content-center">
              <a target="_blank" href="https://www.seos.app/privacy" class="privacy-policy">Privacy Policy</a>
            </div>
          </div>
        </ion-col>
      </ng-container>
      <ng-container *ngIf="hasPairedLoginToken">
        <ion-col size-lg="8" size="12">
          <div class="title">{{ 'LOGIN.LOGIN_AS_OVIS' | translate }}</div>

          <ng-container *ngIf="currentIconView === 'groupIcons'">
            <div id="group-icon-wrapper">
              <div class="icon align-middle text-center group-wrapper" *ngFor="let group of groups" [class.selected]="selectedGroupIconId === group.id"
                   (click)="onSelectGroupIcon(group)">
                <ion-label *ngIf="group.icon" class="group-label" style="font-size: 128px">{{group.icon}}</ion-label>
                <ion-label *ngIf="!group.icon" class="group-label ion-text-center" style="font-size: 24px">{{group.visualId}}</ion-label>
              </div>
            </div>
            <div class="chevron-wrapper">
              <ion-fab-button color="primary" [disabled]="true">
                <ion-icon name="chevron-back"></ion-icon>
              </ion-fab-button>
              <ion-fab-button color="primary" [disabled]="selectedGroupIconId === -1" (click)="nextToUserIcons()">
                <ion-icon name="chevron-forward"></ion-icon>
              </ion-fab-button>
            </div>
          </ng-container>

          <ng-container *ngIf="currentIconView === 'userIcons'">
            <div id="user-icon-wrapper">
              <div class="icon small align-middle text-center group-wrapper" *ngFor="let userIcon of users" [class.selected]="selectedUserIconId === userIcon.id"
                   (click)="onSelectUserIcon(userIcon)">
                <ion-label *ngIf="userIcon.icon" class="group-label" style="font-size: 108px">{{userIcon.icon}}</ion-label>
                <ion-label *ngIf="!userIcon.icon" class="group-label ion-text-center" style="font-size: 24px">{{userIcon.name}}</ion-label>
              </div>
            </div>
            <div class="chevron-wrapper">
              <ion-fab-button color="primary" (click)="backToGroupIcons()">
                <ion-icon name="chevron-back"></ion-icon>
              </ion-fab-button>
              <ion-fab-button color="primary" [disabled]="selectedUserIconId === -1" (click)="onSubmitIcons()">
                <ion-icon name="chevron-forward"></ion-icon>
              </ion-fab-button>
            </div>
          </ng-container>

        </ion-col>
      </ng-container>
    </ion-row>
  </ion-grid>
  <ion-fab *ngIf="logoClickCounter >= minClickNum" vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button *ngIf="!hasPairedLoginToken" size="small" (click)="navigateToRegister()">
      <ion-icon name="lock-closed"></ion-icon>
    </ion-fab-button>
    <ion-fab-button *ngIf="hasPairedLoginToken" color="danger" size="small" (click)="clearPairedLoginToken()">
      <ion-icon name="lock-open"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-content>
